/**
 * @generated SignedSource<<c84e0288266bc36cb434f83d7a0039a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddFachberaterRewardInput = {
  certificateTemplateId: string;
  clientMutationId?: string | null | undefined;
  contentNodeId: string;
};
export type CreateFachberaterRewardButton_AddEmailRewardV2Mutation$variables = {
  input: AddFachberaterRewardInput;
};
export type CreateFachberaterRewardButton_AddEmailRewardV2Mutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly addFachberaterReward: {
        readonly contentNode: {
          readonly " $fragmentSpreads": FragmentRefs<"RewardEditor_TreeNodeFragment">;
        };
      } | null | undefined;
    };
  };
};
export type CreateFachberaterRewardButton_AddEmailRewardV2Mutation = {
  response: CreateFachberaterRewardButton_AddEmailRewardV2Mutation$data;
  variables: CreateFachberaterRewardButton_AddEmailRewardV2Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  (v2/*: any*/)
],
v7 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CertificateTemplate",
    "kind": "LinkedField",
    "name": "certificateTemplate",
    "plural": false,
    "selections": (v6/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "certificateTemplateRef",
    "storageKey": null
  }
],
v8 = [
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateFachberaterRewardButton_AddEmailRewardV2Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddFachberaterRewardPayload",
                "kind": "LinkedField",
                "name": "addFachberaterReward",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "RewardEditor_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateFachberaterRewardButton_AddEmailRewardV2Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddFachberaterRewardPayload",
                "kind": "LinkedField",
                "name": "addFachberaterReward",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "rewards",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isReward"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "recipientType",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "subject",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "body",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "previewText",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "attachCertificates",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "EmailRewardConfiguration",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v5/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PointPool",
                                        "kind": "LinkedField",
                                        "name": "pointPool",
                                        "plural": false,
                                        "selections": (v6/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "PointsRewardConfiguration",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v7/*: any*/),
                                    "type": "CertificateRewardConfiguration",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v7/*: any*/),
                                    "type": "MakeFachberaterRewardConfiguration",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v8/*: any*/),
                                    "type": "AwardPacPointsRewardConfiguration",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v8/*: any*/),
                                    "type": "AwardPharmaPointsRewardConfiguration",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ContentTypeDefinition",
                            "abstractKey": "__isContentTypeDefinition"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "rewards",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ELearningContentTypeDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cf5fc267a12cfa244ee27050460df878",
    "id": null,
    "metadata": {},
    "name": "CreateFachberaterRewardButton_AddEmailRewardV2Mutation",
    "operationKind": "mutation",
    "text": "mutation CreateFachberaterRewardButton_AddEmailRewardV2Mutation(\n  $input: AddFachberaterRewardInput!\n) {\n  Admin {\n    Tree {\n      addFachberaterReward(input: $input) {\n        contentNode {\n          ...RewardEditor_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment CertificatesRewardConfigurationForm_CertificateRewardConfigurationV2Fragment on CertificateRewardConfiguration {\n  id\n  certificateTemplateRef\n}\n\nfragment CreateAwardPacPointsRewardButton_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      rewards {\n        __typename\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment CreateAwardPharmaPointsRewardButton_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      rewards {\n        __typename\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment CreateCertificatesRewardButton_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      rewards {\n        __typename\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment CreateEmailRewardButton_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      rewards {\n        __typename\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment CreateFachberaterRewardButton_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      rewards {\n        __typename\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment EditAwardPacPointsConfigurationForm_AwardPacPointsFragment on AwardPacPointsRewardConfiguration {\n  id\n  amount\n}\n\nfragment EditAwardPacPointsConfigurationForm_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      rewards {\n        __typename\n        id\n        ... on PointsRewardConfiguration {\n          pointPool {\n            name\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EditAwardPharmaPointsConfigurationForm_AwardPharmaPointsFragment on AwardPharmaPointsRewardConfiguration {\n  id\n  amount\n}\n\nfragment EditAwardPharmaPointsConfigurationForm_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      rewards {\n        __typename\n        id\n        ... on PointsRewardConfiguration {\n          pointPool {\n            name\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EditFachberaterRewardConfigurationForm_MakeFachberaterRewardConfigurationFragment on MakeFachberaterRewardConfiguration {\n  id\n  certificateTemplateRef\n}\n\nfragment EmailRewardConfigurationForm_EmailRewardConfigurationV2Fragment on EmailRewardConfiguration {\n  id\n  subject\n  body\n  previewText\n  recipientType\n  attachCertificates\n}\n\nfragment EmailRewardConfigurationForm_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      rewards {\n        __typename\n        id\n        ... on PointsRewardConfiguration {\n          pointPool {\n            name\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment RewardEditor_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      rewards {\n        __typename\n        id\n        kind\n        ... on EmailRewardConfiguration {\n          recipientType\n          subject\n        }\n        ... on PointsRewardConfiguration {\n          amount\n          pointPool {\n            name\n            id\n          }\n        }\n        ... on CertificateRewardConfiguration {\n          certificateTemplate {\n            name\n            id\n          }\n        }\n        ... on MakeFachberaterRewardConfiguration {\n          certificateTemplate {\n            name\n            id\n          }\n        }\n        ... on AwardPacPointsRewardConfiguration {\n          amount\n        }\n        ... on AwardPharmaPointsRewardConfiguration {\n          amount\n        }\n        ...RewardForm_RewardConfigurationV2Fragment\n      }\n    }\n  }\n  ...RewardForm_TreeNodeFragment\n  ...CreateCertificatesRewardButton_TreeNodeFragment\n  ...CreateEmailRewardButton_TreeNodeFragment\n  ...CreateFachberaterRewardButton_TreeNodeFragment\n  ...CreateAwardPacPointsRewardButton_TreeNodeFragment\n  ...CreateAwardPharmaPointsRewardButton_TreeNodeFragment\n}\n\nfragment RewardForm_RewardConfigurationV2Fragment on Reward {\n  __isReward: __typename\n  id\n  kind\n  ... on EmailRewardConfiguration {\n    ...EmailRewardConfigurationForm_EmailRewardConfigurationV2Fragment\n  }\n  ... on AwardPacPointsRewardConfiguration {\n    ...EditAwardPacPointsConfigurationForm_AwardPacPointsFragment\n  }\n  ... on AwardPharmaPointsRewardConfiguration {\n    ...EditAwardPharmaPointsConfigurationForm_AwardPharmaPointsFragment\n  }\n  ... on CertificateRewardConfiguration {\n    ...CertificatesRewardConfigurationForm_CertificateRewardConfigurationV2Fragment\n  }\n  ... on MakeFachberaterRewardConfiguration {\n    ...EditFachberaterRewardConfigurationForm_MakeFachberaterRewardConfigurationFragment\n  }\n}\n\nfragment RewardForm_TreeNodeFragment on TreeNode {\n  id\n  ...EmailRewardConfigurationForm_TreeNodeFragment\n  ...EditAwardPacPointsConfigurationForm_TreeNodeFragment\n  ...EditAwardPharmaPointsConfigurationForm_TreeNodeFragment\n}\n"
  }
};
})();

(node as any).hash = "07f6a9867246a00fca38d7cb61f51832";

export default node;
